import { render, staticRenderFns } from "./CheckupRow.vue?vue&type=template&id=be9a1a38&"
import script from "./CheckupRow.vue?vue&type=script&lang=js&"
export * from "./CheckupRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports